// extracted by mini-css-extract-plugin
module.exports = {"app":"app_app__cewju","grid":"app_grid__3q1Fx","addColor":"app_addColor__36sI8"};